import React from 'react';

// custom components //
import { EditTimelineBookingForm } from "_molecules";
import { useSelector } from 'react-redux';
import { selectJob } from '_redux/slices/utils/menu-context';
import EditTask from './edit-task-form';

const EditTimelineBooking = (props) => {
    const job = useSelector(selectJob);

    return (
        <div style={{ zIndex: "initial" }}>
            {job?.assignedTime ? <EditTask /> :
                <EditTimelineBookingForm
                    close={props.onClose}
                    locationSelectTitle={props?.locationSelectTitle ?? ""}
                    btnTitle={props?.btnTitle ?? ""}
                    placeholder={props?.placeholder ?? ""}
                    forCheckIn={props?.forCheckIn ?? false}
                />}
        </div>
    )
}

export default EditTimelineBooking